// extracted by mini-css-extract-plugin
export default {"container":"PF-z","modal":"QF-z","dimensions":"RF-z","brandName":"SF-z","productName":"TF-z","labelValue":"UF-z","recipientEmail":"VF-z","recommendedFit":"WF-z","hiddenField":"XF-z"};